<template>
  <div id="managingholds">
    <div class="header flex-between">
      <div class="header-text">
        <h1>会员预约管理</h1>
      </div>

      <div class="header-button">
        <el-button
          v-if="jurisdiction.search"
          icon="iconfont icon-sousuo1"
          @click="clearSortpaging1()"
          >查询</el-button
        >
        <el-button
          v-if="jurisdiction.create"
          icon="iconfont icon-chuangjian1"
          @click="onclikebtn"
          >创建</el-button
        >
        <el-button
          v-if="jurisdiction.edit"
          icon="iconfont icon-xiugai1"
          @click="modification(true)"
          >修改</el-button
        >
        <el-button
          v-if="jurisdiction.delete"
          icon="iconfont icon-a-shanchu11"
          @click="delectTankuang"
          >删除</el-button
        >
        <el-button
          v-if="jurisdiction.look"
          icon="el-icon-view"
          @click="modification(false)"
          >查看</el-button
        >
      </div>
    </div>
    <!--创建弹窗  -->
    <div class="create">
      <el-dialog
        width="20%"
        title="请选择创建的类型"
        :visible.sync="createVisible"
        :close-on-click-modal="false"
      >
        <div>
          <el-form
            size="mini"
            :label-position="labelPosition"
            label-width="100px"
            :model="formLabelAlign"
          >
            <div style="width: 300px; height: 100px; margin-top: 30px">
              <el-form-item label="">
                <el-button @click="typeShow(1)">售后服务</el-button>
                <el-button @click="typeShow(0)">试衣预约</el-button>
              </el-form-item>
            </div>
          </el-form>
        </div>
      </el-dialog>
    </div>
    <!-- 会员预约创建售后 -->
    <div class="after">
      <el-dialog
        width="45%"
        title="会员预约-创建-售后"
        :visible.sync="saleVisible"
        :close-on-click-modal="false"
        @close="clonebtn"
      >
        <div>
          <el-form
            size="mini"
            :label-position="labelPosition2"
            label-width="100px"
            :model="LinshiData"
            :rules="rules"
            ref="ruleForm"
          >
            <el-row :gutter="50">
              <el-col :span="12">
                <el-form-item label="预约编号">
                  <el-input
                    v-model="LinshiData.appointmentNo"
                    :disabled="true"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="预约类型">
                  <el-select
                    disabled
                    v-model="LinshiData.kind"
                    placeholder="请选择"
                    style="width: 100%"
                  >
                    <el-option
                      v-for="item in moldgen"
                      :key="item.code"
                      :label="item.text"
                      :value="item.code"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="顾客姓名">
                  <el-input
                    v-model="LinshiData.custName"
                    style="width: 50%"
                    :disabled="true"
                  ></el-input>
                  <el-button style="margin-left: 10px" @click="xuanzhebtn"
                    >选择会员</el-button
                  >
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item label="预约门店" prop="shop">
                  <el-select
                    v-model="LinshiData.shop"
                    placeholder="请选择"
                    style="width: 100%"
                  >
                    <el-option
                      v-for="item in Sking"
                      :key="item.id"
                      :label="item.shopName"
                      :value="item.shopID"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="50">
              <el-col :span="12">
                <el-form-item label="预约日期" prop="appointmentDate">
                  <el-date-picker
                    v-model="LinshiData.appointmentDate"
                    type="date"
                    placeholder="选择日期"
                    value-format="yyyy-MM-dd"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="预约时间" prop="startTime">
                  <el-time-picker
                    v-model="LinshiData.startTime"
                    value-format="HH:mm"
                    style="width: 100%"
                  >
                  </el-time-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="50">
              <el-col :span="12">
                <el-form-item label="预约状态" prop="state">
                  <el-input v-model="LinshiData.Booking" readonly> </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="预约备注" prop="remark">
                  <el-input v-model="LinshiData.remark"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="50">
              <el-col :span="12"> </el-col>
              <el-col :span="12">
                <el-form-item label="服务类型" prop="serviceType">
                  <el-select
                    v-model="LinshiData.serviceType"
                    placeholder="请选择"
                    style="width: 100%"
                  >
                    <el-option
                      v-for="item in curdata"
                      :key="item.code"
                      :label="item.text"
                      :value="item.code"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="100">
              <el-col :span="9" style="width: 100%">
                <el-form-item label="售后图片">
                  <div style="width: 100%">
                    <span style="color: #c9b916"
                      >说明：最多3张图片，规格：长*宽；格式：JPG，PNG；大小：xxMB</span
                    >
                  </div>
                  <el-upload
                    :http-request="handleImports"
                    :limit="3"
                    ref="upload"
                    action="#"
                    list-type="picture-card"
                    style="margin-top: 20px"
                  >
                    <i class="el-icon-plus"></i>
                  </el-upload>
                  <el-dialog>
                    <img width="100%" alt="" />
                  </el-dialog>
                </el-form-item>
              </el-col>
              <el-col :span="9"> </el-col>
            </el-row>
            <el-row :gutter="50">
              <el-col :span="12"> </el-col>
              <el-col :span="12"> </el-col>
            </el-row>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="addData">保 存</el-button>
          <el-button @click="cancelBtn">取 消</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 创建-试衣弹窗  -->
    <div class="fittin">
      <el-dialog
        width="40%"
        title="会员预约-创建--试衣"
        :visible.sync="fittingVisible"
        :close-on-click-modal="false"
        @close="clonebtns"
      >
        <div>
          <el-form
            size="mini"
            :label-position="labelPosition2"
            label-width="100px"
            :model="Linse"
            ref="ruleForms"
            :rules="rulesd"
          >
            <el-row :gutter="50">
              <el-col :span="12">
                <el-form-item label="预约编号">
                  <el-input
                    v-model="LinshiData.appointmentNo"
                    :disabled="true"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="预约类型">
                  <el-select
                    disabled
                    v-model="LinshiData.kind"
                    placeholder="请选择"
                    style="width: 100%"
                  >
                    <el-option
                      v-for="item in moldgen"
                      :key="item.code"
                      :label="item.text"
                      :value="item.code"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="50">
              <el-col :span="12">
                <el-form-item label="顾客姓名">
                  <el-input
                    :disabled="true"
                    v-model="LinshiData.custName"
                    style="width: 180px"
                  ></el-input>
                  <el-button style="margin-left: 8px" @click="xuanzhebtn"
                    >选择会员</el-button
                  >
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="预约门店" prop="shop">
                  <el-select
                    v-model="Linse.shop"
                    placeholder="请选择"
                    style="width: 100%"
                  >
                    <el-option
                      v-for="item in Sking"
                      :key="item.id"
                      :label="item.shopName"
                      :value="item.shopID"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="50">
              <el-col :span="12">
                <el-form-item label="预约日期" prop="appointmentDate">
                  <el-date-picker
                    v-model="Linse.appointmentDate"
                    type="date"
                    placeholder="选择日期"
                    value-format="yyyy-MM-dd"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="预约时间">
                  <el-time-picker
                    v-model="Linse.startTime"
                    value-format="HH:mm"
                    style="width: 100%"
                  >
                  </el-time-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="50">
              <el-col :span="12">
                <el-form-item label="预约状态" prop="state">
                  <el-input v-model="LinshiData.Booking" readonly></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="预约备注">
                  <el-input v-model="Linse.remark"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="50"> </el-row>
            <el-row :gutter="50">
              <el-col :span="12">
                <el-button
                  class="boxsize"
                  icon="el-icon-plus"
                  @click="experimental = true"
                ></el-button>
                <el-button
                  icon="el-icon-minus"
                  class="boxsizeuu"
                  @click="deletebtn"
                ></el-button>
                <el-form-item label="试衣商品SKU">
                  <div class="boxstr" @click="pitchup($event)">
                    <li
                      v-for="(item, index) in LinshiData.keys"
                      :key="index"
                      :data-name="item.sku"
                      :class="{
                        changeStyle: rSelect.indexOf(item.sku) != -1,
                      }"
                    >
                      {{ item.sku }}
                    </li>
                  </div>
                  <div></div>
                </el-form-item>
              </el-col>
              <el-col :span="12"> </el-col>
            </el-row>
          </el-form>
        </div>
        <div style="margin-top: 10px; padding: 0 50px 0 50px">
          <el-form
            size="mini"
            :label-position="labelPosition"
            label-width="100px"
            :model="LinshiData"
          >
          </el-form>
        </div>

        <div slot="footer" class="dialog-footer">
          <el-button @click="addDateincrease">保 存</el-button>
          <el-button @click="Exception">取 消</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 修改-售后弹窗  -->
    <div class="after">
      <el-dialog
        width="45%"
        :title="type ? '会员预约-修改-售后' : '会员预约-查看-售后'"
        :visible.sync="afterVisible"
        :close-on-click-modal="false"
      >
        <div>
          <el-form
            size="mini"
            :label-position="labelPosition2"
            label-width="100px"
            :model="usercur"
          >
            <el-row :gutter="50">
              <el-col :span="12">
                <el-form-item label="预约编号">
                  <el-input
                    v-model="usercur.appointmentNo"
                    :disabled="true"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="预约类型">
                  <el-select
                    disabled
                    v-model="usercur.kind"
                    placeholder="请选择"
                    style="width: 100%"
                  >
                    <el-option
                      v-for="item in moldgen"
                      :key="item.code"
                      :label="item.text"
                      :value="item.code"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="顾客姓名">
                  <el-input
                    v-model="usercur.custName"
                    style="width: 70%"
                    :disabled="true"
                  ></el-input>
                  <el-button style="margin-left: 20px" @click="xuanzhebtn"
                    >选择会员</el-button
                  >
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item label="预约门店">
                  <el-select
                    :disabled="!type"
                    v-model="usercur.shop"
                    placeholder="请选择"
                    style="width: 100%"
                  >
                    <el-option
                      v-for="item in Sking"
                      :key="item.id"
                      :label="item.shopName"
                      :value="item.shopID"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="50">
              <el-col :span="12">
                <el-form-item label="预约日期">
                  <el-date-picker
                    :disabled="!type"
                    v-model="usercur.appointmentDate"
                    type="date"
                    placeholder="选择日期"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="预约时间">
                  <el-time-picker
                    :disabled="!type"
                    v-model="usercur.startTime"
                    value-format="HH:mm"
                    style="width: 100%"
                  >
                  </el-time-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="50">
              <el-col :span="12">
                <el-form-item label="预约状态">
                  <el-select
                    :disabled="!type"
                    v-model="usercur.state"
                    placeholder="请选择"
                    style="width: 100%"
                    @change="maxbacking"
                  >
                    <el-option
                      v-for="item in Sexing"
                      :key="item.code"
                      :label="item.text"
                      :value="item.code"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="预约备注">
                  <el-input
                    :disabled="!type"
                    v-model="usercur.remark"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="50">
              <el-col :span="12">
                <el-form-item label="预约取消原因" v-if="usercur.state != 0">
                  <el-select
                    :disabled="!type"
                    v-model="usercur.cancelReasonID"
                    placeholder="请选择"
                    style="width: 100%"
                    @change="myback"
                  >
                    <el-option
                      v-for="item in surdata"
                      :key="item.reasonID"
                      :label="item.reason_CN"
                      :value="item.reasonID"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="服务类型">
                  <el-select
                    :disabled="!type"
                    v-model="usercur.serviceType"
                    placeholder="请选择"
                    style="width: 100%"
                  >
                    <el-option
                      v-for="item in curdata"
                      :key="item.code"
                      :label="item.text"
                      :value="item.code"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="50">
              <el-col :span="12">
                <el-form-item
                  label="取消原因备注"
                  v-if="usercur.state != 0"
                  prop="cancelOtherReason"
                >
                  <el-input
                    :disabled="disadbycool || !type"
                    v-model="usercur.cancelOtherReason"
                  ></el-input
                  ><br />
                </el-form-item>
                <el-col :span="9" style="width: 100%; margin-left: -20px">
                  <el-form-item label="售后图片">
                    <img
                      width="45%"
                      v-for="(item, index) in imagesArray"
                      :key="index"
                      :src="item"
                      @click="imaArrList(index)"
                      style="margin-top: 10px; margin-left: 10px"
                    />
                    <el-upload
                      :http-request="handleImportsd"
                      action="#"
                      v-if="type"
                      :show-file-list="false"
                      list-type="picture-card"
                      style="margin-top: 10px"
                    >
                      <i class="el-icon-plus"></i>
                    </el-upload>
                  </el-form-item>
                </el-col>
              </el-col>
            </el-row>
            <el-row :gutter="50">
              <el-col :span="12"> </el-col>
              <el-col :span="12"> </el-col>
            </el-row>
          </el-form>
        </div>
        <!-- 查看消息时显示 -->
        <el-form
          size="mini"
          :label-position="labelPosition2"
          label-width="100px"
          :model="usercur"
          v-if="!type"
        >
          <el-row :gutter="50">
            <el-col :span="12">
              <el-form-item label="创建人">
                <el-input
                  v-model="usercur.createUserName"
                  :disabled="true"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="创建日期">
                <el-date-picker
                  v-model="usercur.createTime"
                  type="date"
                  placeholder=""
                  :disabled="true"
                  style="width: 100%"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="50">
            <el-col :span="12">
              <el-form-item label="最后修改人">
                <el-input
                  v-model="usercur.updateUserName"
                  style="width: 100%"
                  :disabled="true"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="最后修改日期">
                <!-- <el-input v-model="usercur.updateTime"
                          :disabled="true"></el-input> -->
                <el-date-picker
                  v-model="usercur.updateTime"
                  type="date"
                  placeholder=""
                  :disabled="true"
                  style="width: 100%"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button v-if="type" @click="reservations">保 存</el-button>
          <el-button @click="afterVisible = false">取 消</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 修改-试衣弹窗  -->
    <div class="fittin">
      <el-dialog
        width="40%"
        :title="type ? '会员预约-修改-试衣' : '会员预约-查看-试衣'"
        :visible.sync="fittinVisible"
        :close-on-click-modal="false"
      >
        <div>
          <el-form
            size="mini"
            :label-position="labelPosition2"
            label-width="100px"
            :model="usercur"
          >
            <el-row :gutter="50">
              <el-col :span="12">
                <el-form-item label="预约编号">
                  <el-input
                    v-model="usercur.appointmentNo"
                    :disabled="true"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="预约类型">
                  <!-- <el-input v-model="usercur.kind" :disabled="true"></el-input> -->
                  <el-select
                    disabled
                    v-model="usercur.kind"
                    placeholder="请选择"
                    style="width: 100%"
                  >
                    <el-option
                      v-for="item in moldgen"
                      :key="item.code"
                      :label="item.text"
                      :value="item.code"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="50">
              <el-col :span="12">
                <el-form-item label="顾客姓名">
                  <el-input
                    v-model="usercur.custName"
                    style="width: 70%"
                    :disabled="true"
                  ></el-input>
                  <el-button style="margin-left: 20px" @click="xuanzhebtn"
                    >选择会员</el-button
                  >
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="预约门店">
                  <!-- <el-input v-model="usercur.shopName"></el-input>
                   -->
                  <el-select
                    :disabled="!type"
                    v-model="usercur.shop"
                    placeholder="请选择"
                    style="width: 100%"
                  >
                    <el-option
                      v-for="item in Sking"
                      :key="item.id"
                      :label="item.shopName"
                      :value="item.shopID"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="50">
              <el-col :span="12">
                <el-form-item label="预约日期">
                  <el-date-picker
                    :disabled="!type"
                    v-model="usercur.appointmentDate"
                    type="date"
                    placeholder="选择日期"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="预约时间">
                  <el-time-picker
                    :disabled="!type"
                    v-model="usercur.startTime"
                    value-format="HH:mm"
                    style="width: 100%"
                  >
                  </el-time-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="50">
              <el-col :span="12">
                <el-form-item label="预约状态">
                  <el-select
                    :disabled="!type"
                    style="width: 100%"
                    v-model="usercur.state"
                    @change="maxbacking"
                  >
                    <el-option
                      v-for="item in Sexing"
                      :key="item.code"
                      :label="item.text"
                      :value="item.code"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="预约备注">
                  <el-input
                    :disabled="!type"
                    v-model="usercur.remark"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="50">
              <el-col :span="12">
                <el-form-item label="预约取消原因" v-show="usercur.state != 0">
                  <el-select
                    :disabled="!type"
                    v-model="usercur.cancelReasonID"
                    placeholder="请选择"
                    style="width: 100%"
                    @change="myback"
                  >
                    <el-option
                      v-for="item in surdata"
                      :key="item.reasonID"
                      :label="item.reason_CN"
                      :value="item.reasonID"
                    ></el-option>
                  </el-select>

                  <!-- <el-select :disabled="!type"
                             v-model="usercur.reasonID"
                             placeholder="请选择"
                             style="width: 100%"
                             @change="myback">
                    <el-option v-for="item in surdata"
                               :key="item.reasonID"
                               :label="item.reason_CN"
                               :value="item.reasonID"></el-option>
                  </el-select> -->
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  label="取消原因备注"
                  ref="form"
                  v-if="usercur.state != 0"
                >
                  <el-input
                    :disabled="disadbycool || !type"
                    v-model="usercur.cancelOtherReason"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="50">
              <el-col :span="12">
                <el-form-item label="试衣商品SKU">
                  <div class="flex-between">
                    <div class="boxstr" @click="pitchupdele($event)">
                      <li
                        v-for="item in usercur.keys"
                        :key="item.appointmentID"
                        :data-name="item.sku"
                        :class="{
                          changeStyle: rSelect.indexOf(item.sku) != -1,
                        }"
                      >
                        {{ item.sku }}
                      </li>
                    </div>
                    <div>
                      <el-button
                        style="
                          background-color: #f2f2f2;
                          color: #4d4d4d;
                          margin-left: 10px;
                        "
                        icon="el-icon-plus"
                        @click="experimental = true"
                      ></el-button>
                      <el-button
                        style="
                          background-color: #f2f2f2;
                          color: #4d4d4d;
                          margin-left: 10px;
                          margin-top: 8px;
                        "
                        icon="el-icon-minus"
                        @click="deleteclear"
                      ></el-button>
                    </div>
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="12"> </el-col>
            </el-row>
          </el-form>
        </div>
        <div style="margin-top: 10px; padding: 0 50px 0 50px">
          <el-form
            size="mini"
            :label-position="labelPosition"
            label-width="100px"
            :model="usercur"
          >
          </el-form>
        </div>

        <el-form
          size="mini"
          :label-position="labelPosition2"
          label-width="100px"
          :model="usercur"
          v-if="!type"
        >
          <el-row :gutter="50">
            <el-col :span="12">
              <el-form-item label="创建人">
                <el-input
                  v-model="usercur.createUserName"
                  :disabled="true"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="创建日期">
                <el-date-picker
                  v-model="usercur.createTime"
                  type="date"
                  placeholder=""
                  :disabled="true"
                  style="width: 100%"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="50">
            <el-col :span="12">
              <el-form-item label="最后修改人">
                <el-input
                  v-model="usercur.updateUserName"
                  style="width: 100%"
                  :disabled="true"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="最后修改日期">
                <el-date-picker
                  v-model="usercur.updateTime"
                  type="date"
                  placeholder=""
                  :disabled="true"
                  style="width: 100%"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button v-if="type" @click="reservation">保 存</el-button>
          <el-button @click="fittinVisible = false">取 消</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 删除弹窗 -->
    <div class="delete">
      <el-dialog
        width="20%"
        title="删除会员预约对话框"
        :visible.sync="deleteFormVisible"
        :close-on-click-modal="false"
      >
        <div style="height: 50px; font-size: 14px; font-weight: 700">
          <p>
            <i
              class="iconfont icon-jingshi"
              style="font-size: 28px; color: #f39b21"
            ></i>
            确定要<span style="color: #ff0000">删除</span>会员预约信息?
          </p>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="delectByID">确 定</el-button>
          <el-button @click="deleteFormVisible = false">取消</el-button>
        </div>
      </el-dialog>
    </div>
    <el-card shadow="never">
      <div class="searchform">
        <el-form
          :label-position="labelPosition"
          label-width="200px"
          :model="formLabelAlign"
          size="small"
        >
          <el-row>
            <el-col :span="8">
              <el-form-item label="会员卡号\会员姓名\手机号">
                <el-input v-model.trim="pagination.search"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="会员消费等级">
                <el-select v-model="pagination.levelID" placeholder="请选择">
                  <el-option
                    v-for="item in resgradeess"
                    :key="item.levelID"
                    :label="item.levelName_cn"
                    :value="item.levelID"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="预约区域">
                <el-select
                  v-model="pagination.regionID"
                  placeholder="请选择"
                  @change="changeSelectCur"
                >
                  <el-option label="全部" value=""> </el-option>
                  <el-option
                    v-for="item in regionList"
                    :key="item.id"
                    :label="item.lable"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="预约门店">
                <el-select v-model="pagination.shopID" placeholder="请选择">
                  <el-option label="全部" value=""> </el-option>
                  <el-option
                    v-for="item in yuedistrict"
                    :key="item.id"
                    :label="item.lable"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-card>
    <el-card shadow="never" class="centercard">
      <el-table
        class="table-style"
        border
        height="450px"
        size="small"
        :row-class-name="tableRowClassName"
        :header-cell-style="{
          background: '#FCFBF2',
          color: '#6C6839',
          'text-align': 'center',
          fontSize: '14px',
        }"
        :cell-style="{ 'text-align': 'center' }"
        ref="multipleTable"
        tooltip-effect="dark"
        v-loading="loading"
        v-el-table-infinite-scroll="loades"
        infinite-scroll-disabled="onLoading"
        :data="list"
      >
        <el-table-column width="40">
          <template slot-scope="scope">
            <el-radio v-model="templateid" :label="scope.row.appointmentID"
              >&nbsp;
            </el-radio>
          </template>
        </el-table-column>
        <el-table-column prop="appointmentNo" label="预约编号">
        </el-table-column>
        <el-table-column prop="kind" label="预约类型">
          <template slot-scope="scope">
            <p v-if="scope.row.kind == 0">试衣预约</p>
            <p v-if="scope.row.kind == 1">售后服务</p>
          </template>
        </el-table-column>
        <el-table-column prop="custName" label="顾客姓名"> </el-table-column>
        <el-table-column prop="shopName" label="门店"> </el-table-column>
        <el-table-column prop="appointmentDate" label="日期">
          <template slot-scope="scope">
            {{ scope.row.appointmentDate | dateFormats }}
          </template>
        </el-table-column>
        <el-table-column prop="startTime" label="时间"> </el-table-column>
        <el-table-column label="预约状态" width="180">
          <template slot-scope="scope">
            <p v-if="scope.row.state == 0">已预约</p>
            <p v-if="scope.row.state == 1">预约取消</p>
          </template>
        </el-table-column>
        <el-table-column prop="createUserName" label="创建人">
        </el-table-column>
        <el-table-column prop="createTime" label="创建日期">
          <template slot-scope="scope">
            {{ scope.row.createTime | dateFormats }}
          </template>
        </el-table-column>
        <el-table-column prop="updateUserName" label="最后修改人">
        </el-table-column>
        <el-table-column prop="updateTime" label="最后修改日期">
          <template slot-scope="scope">
            <div v-if="scope.row.updateTime != null">
              {{ scope.row.updateTime | dateFormats }}
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-alert
        v-if="isMore"
        title="没有更多数据了!"
        type="warning"
        center
        :closable="false"
      >
      </el-alert>
    </el-card>
    <!-- 试衣选择会员弹框 -->
    <div class="fittin">
      <el-dialog
        width="70%"
        title="顾客维护记录—创建—选择会员"
        :visible.sync="basculemovement"
        :close-on-click-modal="false"
      >
        <el-form
          :inline="true"
          :model="formLabelAlign"
          class="demo-form-inline"
        >
          <el-form-item label="会员卡号\会员姓名\手机号">
            <el-input
              v-model.trim="pagination.search"
              placeholder=""
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button icon="iconfont icon-sousuo1" @click="Usermembers"
              >查询</el-button
            >
          </el-form-item>
        </el-form>

        <el-table
          class="table-style"
          border
          size="small"
          :row-class-name="tableRowClassName"
          :header-cell-style="{
            background: '#FCFBF2',
            color: '#6C6839',
            'text-align': 'center',
            fontSize: '14px',
          }"
          :cell-style="{ 'text-align': 'center' }"
          ref="multipleTable"
          tooltip-effect="dark"
          :data="Usersex"
          v-loading="loading"
          v-el-table-infinite-scroll="loadest"
          infinite-scroll-disabled="onLoading"
        >
          <el-table-column width="40">
            <template slot-scope="scope">
              <el-radio v-model="vipid" :label="scope.row.custID"
                >&nbsp;
              </el-radio>
            </template>
          </el-table-column>
          <el-table-column prop="cardNo" label="会员卡号"> </el-table-column>
          <el-table-column prop="custName" label="会员姓名"> </el-table-column>
          <el-table-column prop="mobile" label="手机号"> </el-table-column>
          <el-table-column prop="levelName" label="消费等级"></el-table-column>
          <el-table-column prop="regionName" label="所属区域">
          </el-table-column>
          <el-table-column label="所属门店" prop="shopName" width="180">
          </el-table-column>
          <el-table-column prop="serviceEmpName" label="维护品牌顾问">
          </el-table-column>
        </el-table>
        <el-alert
          v-if="isMore"
          title="没有更多数据了!"
          type="warning"
          center
          :closable="false"
        >
        </el-alert>
        <div slot="footer" class="dialog-footer">
          <el-button @click="Resfitting">保 存</el-button>
          <el-button @click="Exception">取消</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 试衣+号商品SKU弹框 -->
    <div class="fittin">
      <el-dialog
        width="80%"
        title="会员预约创建—选择试衣商品"
        :visible.sync="experimental"
        :close-on-click-modal="false"
      >
        <el-form :inline="true" :model="searchSkuship" class="demo-form-inline">
          <el-form-item label="商品名称/商品SKU">
            <el-input v-model="searchSkuship.search" placeholder=""></el-input>
          </el-form-item>
          <el-form-item>
            <el-button icon="iconfont icon-sousuo1" @click="Searchbtn"
              >查询</el-button
            >
          </el-form-item>
        </el-form>

        <el-table
          class="table-style"
          border
          height="530px"
          size="small"
          :row-class-name="tableRowClassName"
          :header-cell-style="{
            background: '#FCFBF2',
            color: '#6C6839',
            'text-align': 'center',
            fontSize: '14px',
          }"
          :cell-style="{ 'text-align': 'center' }"
          ref="multipleTable"
          v-loading="loading"
          v-el-table-infinite-scroll="load"
          :data="skuship"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column prop="sku" label="商品SKU"> </el-table-column>
          <el-table-column
            prop="productNameCN"
            label="商品名称"
          ></el-table-column>
          <el-table-column prop="categoryNameCN" label="商品分类">
          </el-table-column>
        </el-table>
        <el-alert
          v-if="this.endRow >= this.total"
          title="没有更多数据了!"
          type="warning"
          center
          :closable="false"
        >
        </el-alert>
        <div slot="footer" class="dialog-footer">
          <el-button @click="affirm">保 存</el-button>
          <el-button @click="experimental = false">取 消</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  // literature,
  redistRict,
  Curepaging,
  regionalQuery,
  resgrade,
  particulars,
  reservation,
  countermand,
  Usermembers,
  Goodssku,
  addpivottablea,
  getinformation,
  delectByID,
  uploadImgApi,
} from "@/api/huiyuanyy";
import { dateTimes } from "@/utils/auth";
export default {
  name: "centre",
  data() {
    return {
      UploadPictures: "https://gftest.redstone.com.cn",
      type: "", //判断是修改还是查看
      searchSkuship: { search: "" },
      loading: false,
      // loadinges: false,
      disadbycool: true,
      count: 1,
      pages: 0,
      radio: "",
      deleteFormVisible: false,
      afterVisible: false,
      fittinVisible: false,
      amendVisible: false,
      fittingVisible: false,
      saleVisible: false,
      createVisible: false,
      basculemovement: false,
      experimental: false,
      labelPosition: "right",
      labelPosition2: "left",
      kindL: "",
      formLabelAlign: {
        name: "",
        region: "",
        type: "",
      },
      headersObj: {
        Authorization: window.localStorage.getItem("token"),
      },
      SelectStyle: "",
      rSelect: [],
      url: "",
      srcList: "",
      endRow: "", //表格已返回条数
      total: "", //表格总条数
      Sexing: [
        {
          code: 0,
          text: "已预约",
        },
        {
          code: 1,
          text: "预约取消",
        },
      ],
      curdata: [
        {
          code: 1,
          text: "服装裁剪",
        },
        {
          code: 2,
          text: "领取商品",
        },
      ],
      moldgen: [
        {
          code: 0,
          text: "试衣预约",
        },
        {
          code: 1,
          text: "售后服务",
        },
      ],
      surdata: [],
      pagination: {
        pageNo: 1,
        pageSize: 50,
        levelID: "",
        regionID: "",
        shopID: "",
        search: "",
      },
      Sking: [],

      Usersex: [], //会员选择会员信息存储
      skuship: [], //存储商品sku列表
      form: {
        resource: "",
      },
      list: [],
      templateid: "",
      profisku: "",
      regionList: [], //预约区域
      yuedistrict: [], //预约门店
      resgradeess: [], //会员消费等级
      custID: "",
      usercur: {},
      skuList: [],
      lingsList: [],
      //创建售后
      LinshiData: {
        appointmentNo: "",
        kind: "",
        custName: "",
        shop: "",
        appointmentDate: "",
        startTime: "",
        state: 0,
        remark: "",
        cancelReasonID: "",
        serviceType: "",
        cancelOtherReason: "",
        imageUrl: "",
        imageUrl2: "",
        imageUrl3: "",
        Booking: "已预约",
        keys: [],
      },
      //创建试衣
      Linse: {
        appointmentNo: "",
        kind: "",
        custName: "",
        shop: "",
        appointmentDate: "",
        startTime: "",
        state: 0,
        remark: "",
        cancelReasonID: "",
        serviceType: "",
        cancelOtherReason: "",
        Booking: "已预约",
      },
      //图片修改路径
      imageClear: [],
      vipid: "",
      rules: {
        remark: [
          { required: true, message: "请输入预约备注", trigger: "blur" },
        ],
        // cancelOtherReason: [
        //   { required: true, message: "请输入原因备注", trigger: "blur" },
        // ],
        serviceType: [
          { required: true, message: "请选择服务类型", trigger: "change" },
        ],
        // cancelReasonID: [
        //   { required: true, message: "请选择预约取消原因", trigger: "change" },
        // ],
        startTime: [
          {
            required: true,
            message: "请输入预约时间",
            trigger: "change",
          },
        ],
        appointmentDate: [
          {
            required: true,
            message: "请输入预约的日期",
            trigger: "change",
          },
        ],
        shop: [
          { required: true, message: "请选择预约门店", trigger: "change" },
        ],
      },
      rulesd: {
        custName: [
          { required: true, message: "请选择用户姓名", trigger: "change" },
        ],
        remark: [
          { required: true, message: "请输入预约备注", trigger: "blur" },
        ],
        serviceType: [
          { required: true, message: "请选择服务类型", trigger: "change" },
        ],
        startTime: [
          {
            required: true,
            message: "请输入预约时间",
            trigger: "change",
          },
        ],
        appointmentDate: [
          {
            required: true,
            message: "请输入预约的日期",
            trigger: "change",
          },
        ],
        shop: [
          { required: true, message: "请选择预约门店", trigger: "change" },
        ],
      },
      coverImage: [],
      //11
      cuiImage: [],
      SkuItem: [],
      imagesArray: [],
      //修改传递sku
      SkusItem: [],
      jurisdiction: {
        search: false,
        create: false,
        edit: false,
        look: false,
        delete: false,
      },
    };
  },

  created() {
    this.clearSortpaging();
    this.regionalQuery();
    this.resgrade();
    this.Goodssku();
    // this.addpivottablea();

    if (localStorage.getItem("lists") !== null) {
      // console.log(localStorage.getItem("lists", this.skuLis));
      this.skuList = JSON.parse(localStorage.getItem("lists", this.skuList));
    }
    let ManagingHolds = JSON.parse(localStorage.getItem("ManagingHolds"));
    console.log(ManagingHolds);
    for (let i = 0; i < ManagingHolds.length; i++) {
      if (ManagingHolds[i].menuName == "查询") {
        this.jurisdiction.search = true;
        continue;
      }
      if (ManagingHolds[i].menuName == "创建") {
        this.jurisdiction.create = true;
        continue;
      }

      if (ManagingHolds[i].menuName == "修改") {
        this.jurisdiction.edit = true;
        continue;
      }
      if (ManagingHolds[i].menuName == "查看") {
        this.jurisdiction.look = true;
        continue;
      }
      if (ManagingHolds[i].menuName == "删除") {
        this.jurisdiction.delete = true;
        continue;
      }
    }
  },
  methods: {
    // 判断如果是单行就变黄色双行是白色
    tableRowClassName({ rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "warning-row";
      }
      return "";
    },
    async clearSortpaging() {
      this.countermand();
      this.count = 1;
      const res = await Curepaging(this.pagination);
      this.list = res.data.list;
    },

    //分页查询信息
    async clearSortpaging1() {
      this.count = 1;
      const res = await Curepaging(this.pagination);
      this.list = res.data.list;
    },
    // //修改功能
    async particulars() {
      await particulars(this.templateid);
      // console.log(res);
    },
    //头部区域请求数据
    async regionalQuery() {
      const res = await regionalQuery();
      this.regionList = res.data;
      // console.log(this.regionList);
    },
    //预约区域请求数据
    async redistRict() {
      const res = await redistRict();
      this.yuedistrict = res.data;
      this.Sking = res.data;
      // console.log(this.Sking);
    },
    //会员消费等级数据初始化
    async resgrade() {
      const res = await resgrade();
      this.resgradeess = res.data;
      // console.log(this.resgradeess);
      // debugger;
    },
    //根据不同的类型进入具体的详情页面
    async circumstance(temp) {
      this.amendVisible = false;
      let data = {
        kind: temp,
        custID: this.custID,
        appointmentID: this.templateid,
      };
      const res = await particulars(data);

      this.imagesArray = [];
      if (res.data.imgFile) {
        this.imagesArray.push(res.data.imgFile);
      }
      if (res.data.imgFile2) {
        this.imagesArray.push(res.data.imgFile2);
      }
      if (res.data.imgFile3) {
        this.imagesArray.push(res.data.imgFile3);
      }

      this.usercur = res.data;
      if (this.usercur.cancelOtherReason != "") {
        this.disadbycool = false;
      }
      if (temp == 0) {
        this.fittinVisible = true;
      } else {
        this.afterVisible = true;
      }
    },
    //修改弹框
    modification(type) {
      this.redistRict();
      this.type = type;
      if (this.templateid == "") {
        // alert("请先选中修改的数据");
        if (type) {
          this.$message.warning("请先选中修改的数据");
        } else {
          this.$message.warning("请先选中查看的数据");
        }
      } else {
        for (let i = 0; i < this.list.length; i++) {
          let item = this.list[i];
          if (item.appointmentID == this.templateid) {
            this.custID = item.custID;
            this.kind = item.kind;
          }
        }
        this.circumstance(this.kind);
      }
    },
    //试衣服修改数据功能
    async reservation() {
      this.usercur.keys.forEach((item) => {
        this.SkusItem.push(item.sku);
      });
      let data = {
        custID: this.usercur.custID,
        custName: this.usercur.custName,
        shopName: this.usercur.shopName,
        appointmentDate: dateTimes(this.usercur.appointmentDate),
        startTime: this.usercur.startTime,
        state: this.usercur.state,
        remark: this.usercur.remark,
        CancelOtherReason: this.usercur.cancelOtherReason,
        cancelReasonID: this.usercur.cancelReasonID,
        kind: this.usercur.kind,
        shop: this.usercur.shop,
        appointmentID: this.usercur.appointmentID,
        skus: this.SkusItem.toString(),
      };

      if (!this.disadbycool && this.usercur.cancelOtherReason == "") {
        this.$message.warning("请填写取消原因备注！");
      } else {
        await reservation(data).then((res) => {
          if (res.message === "success") {
            this.$message.success("修改成功");
            this.fittinVisible = false;
            this.usercur = {};
            this.SkusItem = [];
            this.clearSortpaging();
          }
        });
      }
    },
    //售后修改
    async reservations() {
      let data = {
        custID: this.usercur.custID,
        templateid: this.usercur.templateid,
        custName: this.usercur.custName,
        shopName: this.usercur.shopName,
        appointmentDate: dateTimes(this.usercur.appointmentDate),
        startTime: this.usercur.startTime,
        state: this.usercur.state,
        remark: this.usercur.remark,
        CancelOtherReason: this.usercur.cancelOtherReason,
        cancelReasonID: this.usercur.cancelReasonID,
        serviceType: this.usercur.serviceType,
        kind: this.usercur.kind,
        shop: this.usercur.shop,
        appointmentID: this.usercur.appointmentID,
        imgFile: this.imagesArray[0],
        imgFile2: this.imagesArray[1],
        imgFile3: this.imagesArray[2],
      };
      if (!this.disadbycool && this.usercur.cancelOtherReason == "") {
        this.$message.warning("请填写取消原因备注！");
      } else {
        await reservation(data).then((res) => {
          if (res.message === "success") {
            this.usercur = {};
            this.cuiImage = [];
            this.surdata = [];
            this.$message.success("修改成功");
            this.afterVisible = false;
            this.clearSortpaging();
          }
        });
      }
    },
    submitForm() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.addData(true);
        } else {
          return false;
        }
      });
    },
    clonebtn() {
      this.$refs.ruleForm.resetFields();
    },
    imaArrList(index) {
      this.imagesArray.splice(index, 1);
    },
    //售后新增数据功能
    addData() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          let data = {
            custID: this.LinshiData.custID,
            custName: this.LinshiData.custName,
            appointmentDate: this.LinshiData.appointmentDate,
            startTime: this.LinshiData.startTime,
            state: this.LinshiData.state,
            remark: this.LinshiData.remark,
            serviceType: this.LinshiData.serviceType,
            kind: this.LinshiData.kind,
            shop: this.LinshiData.shop,
            appointmentNo: this.LinshiData.appointmentNo,
            imgFile: this.coverImage[0],
            imgFile2: this.coverImage[1],
            imgFile3: this.coverImage[2],
          };
          addpivottablea(data).then((res) => {
            if (res.message == "success") {
              this.LinshiData = {};
              this.vipid = "";
              this.coverImage = [];
              this.LinshiData.state = "0";
              this.LinshiData.Booking = "已预约";
              this.$refs.upload.clearFiles();
              this.$message.success("创建成功！");
              this.saleVisible = false;
              this.clearSortpaging();
            }
          });
        }
      });
    },
    clonebtns() {
      this.$refs.ruleForms.resetFields();
    },
    //试衣新增功能
    addDateincrease() {
      this.$refs.ruleForms.validate((valid) => {
        if (valid) {
          if (this.LinshiData.keys.length > 0) {
            this.LinshiData.keys.forEach((item) => {
              if (item.sku) {
                this.SkuItem.push(item.sku);
              }
            });
          }

          let data = {
            custID: this.LinshiData.custID,
            custName: this.LinshiData.custName,
            appointmentDate: this.Linse.appointmentDate,
            startTime: this.Linse.startTime,
            state: this.LinshiData.state,
            remark: this.Linse.remark,
            kind: this.LinshiData.kind,
            shop: this.Linse.shop,
            appointmentNo: this.LinshiData.appointmentNo,
            skus: this.SkuItem.toString(),
          };
          addpivottablea(data).then((res) => {
            if (res.message == "success") {
              this.LinshiData = {};
              this.Linse = {};
              this.vipid = "";
              this.SkuItem = [];
              this.LinshiData.state = "0";
              this.LinshiData.Booking = "已预约";
              this.$message.success("创建成功！");
              this.fittingVisible = false;
              this.clearSortpaging();
            }
          });
        }
      });
    },
    //取消预约原因接口
    async countermand() {
      const res = await countermand({ reasonKind: 101 });
      this.surdata = res.data;
    },
    //试衣功能修改
    Resfitting() {
      for (let i = 0; i < this.Usersex.length; i++) {
        const item = this.Usersex[i];
        if (item.custID === this.vipid) {
          this.usercur.custName = item.custName;
          this.usercur.custID = item.custID;
          this.LinshiData.custName = item.custName;
          this.LinshiData.custID = item.custID;
          this.basculemovement = false;
        }
      }
    },
    //获取选择会员信息
    async Usermembers() {
      let barse = {
        pageNo: "1",
        pageSize: "50",
        search: this.pagination.search,
      };
      const res = await Usermembers(barse);
      this.Usersex = res.data.list;
    },
    //试衣--选择商品保存
    affirm() {
      this.usercur.keys = this.lingsList;
      this.LinshiData.keys = this.lingsList;
      this.$forceUpdate();
      this.$message({
        message: "添加成功",
        type: "success",
      });

      this.experimental = false;
    },
    //获取商品SKU列表
    async Goodssku() {
      let clickes = {
        pageNo: this.count,
        pageSize: 20,
        search: this.searchSkuship.search,
      };
      await Goodssku(clickes).then((res) => {
        if (res.data.total < this.skuship.length) return;
        this.skuship = this.skuship.concat(res.data.list);
        this.endRow = res.data.endRow;
        this.pages = res.data.pages;
        this.total = res.data.total;
        this.loading = false;
      });
    },
    async Searchbtn() {
      let clickes = {
        pageNo: this.count,
        pageSize: 20,
        search: this.searchSkuship.search,
      };
      await Goodssku(clickes).then((res) => {
        this.skuship = res.data.list;
      });
    },
    handleSelectionChange(val) {
      // console.log(val);
      this.lingsList = val;
      return val;
    },
    //会员预约-创建--试衣S滚动加载
    load() {
      this.loading = true;
      setTimeout(() => {
        this.count += 1;
        this.Goodssku();
      }, 500);
    },
    //会员预约-..........动加载
    loades() {
      this.loading = true;
      setTimeout(() => {
        this.count += 1;
        this.dataList();
      }, 1000);
    },
    //列表数据
    dataList() {
      Curepaging({
        pageNo: this.count,
        pageSize: this.pagination.pageSize,
      }).then((res) => {
        this.list = this.list.concat(res.data.list);
        this.pages = res.data.pages;
        this.total = res.data.total;
        this.endRow = res.data.endRow;
        this.loading = false;
      });
    },
    //选择会员滚动加载
    loadest() {
      this.loading = true;
      setTimeout(() => {
        this.count += 1;
        this.dataListes();
      }, 1000);
    },
    //选择会员列表数据
    dataListes() {
      Usermembers({
        pageNo: this.count,
        pageSize: "50",
      }).then((res) => {
        this.Usersex = this.Usersex.concat(res.data.list);
        this.pages = res.data.pages;
        this.loading = false;
      });
    },
    //根据类型进入到不同的创建弹框
    typeShow(type) {
      this.LinshiData.kind = type;
      this.getinformation();
      this.$forceUpdate();
      if (type === 1) {
        this.saleVisible = true;
        this.createVisible = false;
      } else {
        this.fittingVisible = true;
        this.createVisible = false;
      }
    },
    //试衣商品suk删除功能
    deletebtn() {
      let arr = [];
      for (let i = 0; i < this.LinshiData.keys.length; i++) {
        let item = this.LinshiData.keys[i];
        arr.push(item.sku);
      }
      for (let i = 0; i < this.rSelect.length; i++) {
        let item = this.rSelect[i];
        if (arr.indexOf(item) !== -1) {
          this.LinshiData.keys.splice(arr.indexOf(item), 1);
        }
      }
      this.$forceUpdate();
    },
    deleteclear() {
      let arr = [];
      for (let i = 0; i < this.usercur.keys.length; i++) {
        let item = this.usercur.keys[i];
        arr.push(item.sku);
      }
      for (let i = 0; i < this.rSelect.length; i++) {
        let item = this.rSelect[i];
        if (arr.indexOf(item) !== -1) {
          this.usercur.keys.splice(arr.indexOf(item), 1);
        }
      }
      this.$forceUpdate();
    },
    //点击选中
    pitchup(e) {
      this.changeSelectStyle = e.target.dataset.name;
      if (this.rSelect.indexOf(e.target.dataset.name) !== -1) {
        this.rSelect.splice(this.rSelect.indexOf(e.target.dataset.name), 1);
      } else {
        this.rSelect.push(e.target.dataset.name);
      }
      this.LinshiData.skus = this.rSelect.join(",");
    },
    //点击选中
    pitchupdele(e) {
      this.changeSelectStyle = e.target.dataset.name;
      if (this.rSelect.indexOf(e.target.dataset.name) !== -1) {
        this.rSelect.splice(this.rSelect.indexOf(e.target.dataset.name), 1);
      } else {
        this.rSelect.push(e.target.dataset.name);
      }
      this.usercur.sku = this.rSelect.join(",");
    },
    //获取预约编号
    async getinformation() {
      let res = await getinformation();
      this.usercur.appointmentNo = res.data;
      this.LinshiData.appointmentNo = res.data;
      this.$forceUpdate();
      // console.log(this.usercur.appointmentNo);
    },
    async delectByID() {
      this.deleteFormVisible = false;
      await delectByID({ appointmentID: this.templateid });
      this.$message.success("删除成功");
      //初始化表格信息
      this.templateid = "";
      this.clearSortpaging();
      this.list = [];
    },
    //删除弹框
    delectTankuang() {
      if (this.templateid == "") {
        this.$message.warning("请先选中删除的数据");
      } else {
        this.deleteFormVisible = true;
      }
    },
    //点击选择会员获取信息
    xuanzhebtn() {
      this.basculemovement = true;
      this.Usermembers();
    },
    //点击取消
    Exception() {
      this.Linse = {};
      this.LinshiData = {};
      this.LinshiData.Booking = "已预约";
      this.fittingVisible = false;

      this.$refs.ruleForms.resetFields();
    },
    //取消时清除校验
    cancelBtn() {
      this.LinshiData = {};
      this.saleVisible = false;
      this.LinshiData.Booking = "已预约";
      this.$refs.ruleForm.resetFields();
    },
    //区域关联门店
    changeSelectCur() {
      for (let k in this.regionList) {
        if (this.pagination.regionID === this.regionList[k].id) {
          this.yuedistrict = this.regionList[k].chlidren;
        }
      }
    },
    //点击创建加载数据
    onclikebtn() {
      this.createVisible = true;
      this.redistRict();
    },
    myback() {
      this.surdata.forEach((item) => {
        if (item.reasonID === this.usercur.cancelReasonID) {
          this.disadbycool = !item.isNeedOtherReason;
          this.usercur.cancelOtherReason = "";
        }
      });
    },
    maxbacking() {
      if (this.usercur.state == 0) {
        this.disadbycool = true;
        this.usercur.cancelReasonID = "";
        this.usercur.cancelOtherReason = "";
      } else {
        this.disadbycool = true;
        this.usercur.cancelReasonID = "";
        this.usercur.cancelOtherReason = "";
      }
    },
    handleImports(file) {
      const params = new FormData();
      params.append("file", file.file);
      uploadImgApi(params)
        .then((res) => {
          if (res.data) {
            this.coverImage.push(res.data);
          }
          this.$message.success("上传成功！");
        })
        .catch(() => {
          this.$message.error("上传失败!");
        });
    },
    handleImportsd(file) {
      const params = new FormData();
      params.append("file", file.file);
      uploadImgApi(params)
        .then((res) => {
          if (res.data && this.imagesArray.length < 3) {
            this.imagesArray.push(res.data);
          } else {
            return this.$message.warning("最多上传三张！");
          }
          this.$message.success("上传成功！");
        })
        .catch(() => {
          this.$message.error("上传失败!");
        });
    },
  },
  computed: {
    isMore() {
      return this.count >= this.pages;
    },
    onLoading() {
      return this.loading || this.isMore;
    },
  },
};
</script>
<style lang="scss" scoped>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
#managingholds {
  // height: 1400px;
  height: 100%;
}
.header-text {
  height: 50px;
  margin-top: 20px;
  color: #76734f;
}
.searchform {
  margin-top: 20px;
}
.centercard {
  margin-top: 10px;
}
.card-pagination {
  margin-top: 20px;
  text-align: right;
}
// 按钮边框去掉，文字颜色和加粗
/deep/button {
  border-color: #e6e0af;
  border-radius: 7px;
  color: #a19b59;
}
/deep/input {
  border-radius: 0 !important;
}
// 去除表头复选框
/deep/.table-style {
  .el-table-column--selection.is-leaf .el-checkbox {
    display: none;
  }
}
.el-table .warning-row {
  background: #fcfbf2;
}

.el-table .success-row {
  background: #ffffff;
}
::v-deep {
  // 改变分页背景色
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #d1cda5 !important;
    color: #ffffff !important;
  }
  // 改变分页字体颜色
  .el-pagination.is-background .btn-next,
  .el-pagination.is-background .btn-prev,
  .el-pagination.is-background .el-pager li {
    color: #d1cda5 !important;
  }
  // 改变table里的按钮图标大小
  .table-button .iconfont {
    font-size: 14px;
  }
  // 设置表单里字体的颜色
  .el-form-item__label {
    color: #76734f;
  }
  .create {
    .el-dialog__header {
      background-color: #f3f1dd;
    }
    .el-dialog__body {
      padding: 0;
    }
    .el-dialog__title {
      font-size: 14px;
      font-weight: 700;
      color: #6c6937;
    }
    .el-dialog__footer {
      height: 60px;
      text-align: center;
      background-color: #f2f2f2;
    }
    .el-button:hover {
      background-color: #b5b386;
      color: #f2f2f2 !important;
    }

    .el-form-item__content {
      line-height: 0px;
    }
  }
  .sale {
    .el-dialog__header {
      background-color: #f3f1dd;
    }
    .el-dialog__body {
      padding: 10px 20px;
    }
    .el-dialog__title {
      font-size: 14px;
      font-weight: 700;
      color: #6c6937;
    }
    .el-dialog__footer {
      height: 60px;
      text-align: center;
      background-color: #f2f2f2;
    }
    .el-button:hover {
      background-color: #b5b386;
      color: #f2f2f2 !important;
    }

    .el-form-item__content {
      line-height: 0px;
    }
  }
  .fitting {
    .el-dialog__header {
      background-color: #f3f1dd;
    }
    .el-dialog__body {
      padding: 10px 20px;
    }
    .el-dialog__title {
      font-size: 14px;
      font-weight: 700;
      color: #6c6937;
    }
    .el-dialog__footer {
      height: 60px;
      text-align: center;
      background-color: #f2f2f2;
    }
    .el-button:hover {
      background-color: #b5b386;
      color: #f2f2f2 !important;
    }

    .el-form-item__content {
      line-height: 0px;
    }
  }
  .amend {
    .el-dialog__header {
      background-color: #f3f1dd;
    }
    .el-dialog__body {
      padding: 10px 20px;
    }
    .el-dialog__title {
      font-size: 14px;
      font-weight: 700;
      color: #6c6937;
    }
    .el-dialog__footer {
      height: 60px;
      text-align: center;
      background-color: #f2f2f2;
    }
    .el-button:hover {
      background-color: #b5b386;
      color: #f2f2f2 !important;
    }

    .el-form-item__content {
      line-height: 0px;
    }
  }
  .after {
    .el-dialog__header {
      background-color: #f3f1dd;
    }
    .el-dialog__body {
      padding: 10px 20px;
    }
    .el-dialog__title {
      font-size: 14px;
      font-weight: 700;
      color: #6c6937;
    }
    .el-dialog__footer {
      height: 60px;
      text-align: center;
      background-color: #f2f2f2;
    }
    .el-button:hover {
      background-color: #b5b386;
      color: #f2f2f2 !important;
    }

    .el-form-item__content {
      line-height: 0px;
    }
    // .el-form-item--mini.el-form-item {
    //   margin-left: -20px;
    // }
  }
  .fittin {
    .el-dialog__header {
      background-color: #f3f1dd;
    }
    .el-dialog__body {
      padding: 10px 20px;
    }
    .el-dialog__title {
      font-size: 14px;
      font-weight: 700;
      color: #6c6937;
    }
    .el-dialog__footer {
      height: 60px;
      text-align: center;
      background-color: #f2f2f2;
    }
    .el-button:hover {
      background-color: #b5b386;
      color: #f2f2f2 !important;
    }

    .el-form-item__content {
      line-height: 0px;
    }
  }
  // 删除弹框样式
  .delete {
    .el-dialog__header,
    .el-message-box__header {
      border-top-left-radius: 9px;
      border-top-right-radius: 9px;
      height: 44px;
      background: #f3f1dd;
      width: 100%;
      text-align: center;
      color: #666;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 20px;
      box-sizing: border-box;
    }
    .el-dialog__title,
    .el-message-box__title {
      color: #6c6937;
      font-weight: 700;
      font-size: 16px !important;
    }
    .el-dialog .el-dialog__body {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .coverage-release .el-dialog__body {
      padding: 20px;
    }
    .el-button:hover {
      background-color: #b6b388;
    }
    .el-dialog__body {
      padding: 30px 60px;
    }
    .el-tabs__item {
      border: 1px solid #d9d9d9;
      background-color: #fff;
      color: #6c6937;
    }
    .el-dialog__footer {
      height: 60px;
      text-align: center;
      background-color: #f2f2f2;
    }

    .el-tabs__item.is-active {
      color: #6c6937;
      background-color: #f3f1dd;
    }
    .el-form-item__content {
      line-height: 0px;
    }
    .el-textarea__inner {
      // 取消拉伸样式
      resize: none;
    }
  }
}
.boxstr {
  width: 100%;
  height: 130px;
  overflow-y: auto;
  border: 1px solid #666;
  li {
    list-style: none;
    line-height: 25px;
    padding-left: 8px;
  }

  .changeStyle {
    color: #fff;
    background-color: #409eff;
  }
  .setime {
    display: flex;
    justify-content: space-around;
  }
}
.boxsize {
  background-color: #f2f2f2;
  color: #4d4d4d;
  margin-left: 46%;
  position: absolute;
  top: 60px;
  left: 13px;
}
.boxsizeuu {
  background-color: #f2f2f2;
  color: #4d4d4d;
  position: relative;
  top: 120px;
  left: 337px;
}
</style>
